import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: '𝕏', label: 'تويتر', url: '#' },
    { icon: '📘', label: 'فيسبوك', url: '#' },
    { icon: '📸', label: 'إنستغرام', url: '#' },
    { icon: '▶️', label: 'يوتيوب', url: '#' },
    { icon: '💬', label: 'واتساب', url: 'https://wa.me/967783124226' },
  ];

  const quickLinks = [
    { path: '/', label: 'الرئيسية' },
    { path: '/about', label: 'من نحن' },
    { path: '/support', label: 'الدعم الفني' },
    { path: '/terms', label: 'الشروط والسياسة' },
  ];

  const contactInfo = [
    {
      icon: '✉️',
      label: 'البريد الإلكتروني',
      value: 'shashatana.ye@gmail.com',
      href: 'mailto:shashatana.ye@gmail.com',
      dir: 'ltr',
    },
    {
      icon: '📞',
      label: 'الهاتف',
      value: '+967 783 124 226',
      href: 'tel:+967783124226',
      dir: 'ltr',
    },
    {
      icon: '💬',
      label: 'واتساب',
      value: '+967 783 124 226',
      href: 'https://wa.me/967783124226',
      dir: 'ltr',
    },
    {
      icon: '📍',
      label: 'الموقع',
      value: 'صنعاء، الجمهورية اليمنية',
      href: null,
      dir: 'rtl',
    },
  ];

  return (
    <footer className="footer">
      {/* Decorative top glow */}
      <div className="footer-glow" />

      <div className="container">
        <div className="footer-grid">
          {/* Brand Column */}
          <div className="footer-brand-col">
            <div className="footer-brand-head">
              <img src="/logo.png" alt="استراحة شاشتنا" className="footer-brand-logo" />
              <div>
                <p className="footer-brand-name">استراحة شاشتنا</p>
                <span className="footer-brand-en">ShashatanaYe</span>
              </div>
            </div>
            <p className="footer-tagline">
              منصة ترفيه سينمائية متكاملة تُقدَّم عبر شبكات الواي فاي المحلية
              في الفنادق والمقاهي والاستراحات، لتستمتع بالأفلام والمسلسلات
              والبودكاست دون الحاجة للإنترنت الخارجي.
            </p>
            <div className="footer-social">
              {socialLinks.map((s) => (
                <a
                  key={s.label}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-btn"
                  title={s.label}
                  aria-label={s.label}
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links-col">
            <h4 className="footer-col-title">روابط سريعة</h4>
            <ul className="footer-links">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="footer-link">
                    <span className="footer-link-arrow">◀</span>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-contact-col">
            <h4 className="footer-col-title">تواصل معنا</h4>
            <div>
              {contactInfo.map((item) => {
                const content = (
                  <>
                    <span className="footer-contact-icon">{item.icon}</span>
                    <div>
                      <div className="footer-contact-label">{item.label}</div>
                      <span
                        className="footer-contact-value"
                        dir={item.dir}
                      >
                        {item.value}
                      </span>
                    </div>
                  </>
                );

                return item.href ? (
                  <a
                    key={item.label}
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-contact-item footer-contact-link"
                  >
                    {content}
                  </a>
                ) : (
                  <div key={item.label} className="footer-contact-item">
                    {content}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="divider" />

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} <span>استراحة شاشتنا</span>. جميع الحقوق محفوظة.
          </p>
          <p className="footer-copyright">
            صُنع بـ <span className="footer-heart">❤️</span> في اليمن لتجربة ترفيهية استثنائية
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;